import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';


import {
    navigate, openDialog, setSaveState
} from '../../actions';

import {
    updateCentroDB
} from '../../actions/centro_actions';

const styles = theme => ({
    buttonsBottom: {
        margin: '10px 15px 30px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});


class CentroActionButtons extends Component {

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkRequiredFields = (centro) => {
        if (!centro.descr) {
            this.messageDialog('Por favor, rellene el campo Nombre');
            return false;
        } else if (!centro.direccion1) {
            this.messageDialog('Por favor, rellene el campo Dirección 1');
            return false;
        }

        else return true;

    };


    updateHandler = () => {

        const cajas = this.props.cajasCentro.cajasCentro.map((c, index) => {
            const { id, ...newCaja } = c;
            if (typeof c.id !== 'string') newCaja.id = c.id;
            return newCaja;
        });

        const zonas = this.props.zonasCentro.zonas.map((c, index) => {
            const { id, ...newZona } = c;
            if (typeof c.id !== 'string') newZona.id = c.id;
            return newZona;
        });

        const contab = this.props.contabCentro.contabCentro.map((c, index) => {
            const { id, ...newContab } = c;
            if (typeof c.id !== 'string') newContab.id = c.id;
            return newContab;
        });

        const tiposZonaIva = this.props.zonaIvaCentro.zonaIvaCentro.map((c, index) => {
            const { id, ...newTipoZonaIva } = c;
            if (typeof c.id !== 'string') newTipoZonaIva.id = c.id;
            return newTipoZonaIva;
        });

        const centrosCentro = this.props.centrosCentro.centros.map((c, index) => {
            const { id, ...newCentro } = c;
            if (typeof c.id !== 'string') newCentro.id = c.id;
            return newCentro;
        });

        const centro = {
            ...this.props.centroDetalle.centrodetalle,
            descr: this.props.centroDetalle.centrodetalle.descr,
            direccion1: this.props.centroDetalle.centrodetalle.direccion1,
            direccion2: this.props.centroDetalle.centrodetalle.direccion2,
            iDiaCierre: this.props.centroDetalle.centrodetalle.iDiaCierre,
            canal: this.props.centroDetalle.centrodetalle.canal,
            empresaId: this.props.centroDetalle.centrodetalle.empresaId,
            caja: cajas,
            zonaPpto: zonas,
            contabTipoMaquinaCentro: contab,
            centroZonaIva: tiposZonaIva,
            grupoCentrosPadre: centrosCentro
        };

        if (this.checkRequiredFields(centro)) {
            this.props.setSaveState(false);
            this.props.updateCentroDB(centro, this.props.match.params.id, () => this.props.navigate("mae_centro"));
        }

    };

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={this.props.backHandler}>Atrás</Button>
                <Button
                    className={classes.buttonsBottom}
                    disabled={this.props.zonasCentro.isLoading || this.props.contabCentro.isLoading || this.props.centroDetalle.isLoading || this.props.zonaIvaCentro.isLoading}
                    variant="contained"
                    color="primary"
                    onClick={() => this.updateHandler()}>
                    Guardar
                </Button>
            </div>
        );
    };

};

CentroActionButtons.propTypes = {
    //state
    cajasCentro: PropTypes.object.isRequired,
    zonasCentro: PropTypes.object.isRequired,
    contabCentro: PropTypes.object.isRequired,
    centroDetalle: PropTypes.object.isRequired,
    zonaIvaCentro: PropTypes.object.isRequired,
    centrosCentro: PropTypes.object.isRequired,
    //dispatch
    updateCentroDB: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        cajasCentro: state.cajasCentro,
        zonasCentro: state.zonasCentro,
        contabCentro: state.contabCentro,
        centroDetalle: state.centroDetalle,
        zonaIvaCentro: state.zonaIvaCentro,
        centrosCentro: state.centrosCentro
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateCentroDB: updateCentroDB,
        navigate,
        openDialog,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(CentroActionButtons)));